import {useEffect} from 'react'
import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetSeedTicketNameList = (seedTicketNameFilter = false) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	useEffect(() => {
		if (seedTicketNameFilter) {
			fetchRequest(
				'GET',
				`/${rolePath}/record_seed_ticket/seed_ticket_name/list`
			)
		}
	}, [seedTicketNameFilter])

	useEffect(() => {
		if (fetchResult) {
			switch (fetchResult?.statusCode) {
				case 400:
					setAlert('데이터를 불러오는데 실패했습니다.')
					break
				case 401:
				case 403:
					setAlert('현재 권한으로 접근할 수 없습니다.')
					break
			}
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetSeedTicketNameList
